import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { ResearcherForm } from '../ResearcherForm';

export class ResearcherDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            researcherId: props.researcherId,
            researcher: null,
            editResearcherDialogOpen: false,
            showTitle: props.showTitle
        };

        this.loadResearcher(props.researcherId);
    }

    loadResearcher(researcherId) {
        if (!researcherId) {
            console.error('Invalid researcher id:', researcherId);
        }

        var url = new URL('/api/contacts/get-researcher', window.location.origin);
        var fetchParams = { id: researcherId };

        url.search = new URLSearchParams(fetchParams).toString();

        fetch(url)
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.error('Failed to get researcher:', response);
                    this.setState({ loadResearcherError: true });
                }
            })
            .then(json => {
                console.log(json);
                this.setState({
                    researcher: {
                        id: json.id,
                        name: json.name,
                        email: json.email,
                        phone: json.phone,
                        institution: json.institution,
                        subInstitution: json.subInstitution,
                        position: json.position,
                        labelEntities: json.labelEntities,
                        clinicalResearchExperience: json.clinicalResearchExperience,
                        clinicalTrialsExperience: json.clinicalTrialsExperience,
                        comment: json.comment
                    }
                });
            })
            .catch(err => {
                console.log('Failed to fetch researcher');
                this.setState({ loadResearcherError: true });
            });
    }

    handleEditResearcherClicked = () => {
        this.setState({ editResearcherDialogOpen: true });
    };

    handleEditResearcherDialogClose = () => {
        this.setState({ editResearcherDialogOpen: false });
    };

    handleResearcherUpdated = (researcher) => {
        this.setState({
            researcher: researcher
        });
    };

    render() {
        if (!this.state.researcherId) {
            return (<p className="alert alert-danger">{this.state.researcherId} is not a valid researcher ID.</p>);
        }

        var researcher = this.state.researcher;

        if (!researcher) {
            return (<p className="alert alert-info">Loading researcher...</p>);
        }

        return (
            <div>
                <div className="d-flex align-items-center">
                {this.state.showTitle &&
                    <h1 className="d-inline-block mr-2">{researcher.name}</h1>
                    }
                    <button type="button" className="btn btn-info" onClick={this.handleEditResearcherClicked}>Edit</button>
                </div>
                <table className="table">
                    <tbody>
                        <tr>
                            <th className="text-right" width="30%">Email</th>
                            <td><a href={"mailto:" + researcher.email}>{researcher.email}</a></td>
                        </tr>
                        <tr>
                            <th className="text-right">Phone</th>
                            <td>{researcher.phone}</td>
                        </tr>
                        <tr>
                            <th className="text-right">College/Department</th>
                            <td>{researcher.institution && researcher.institution.label}</td>
                        </tr>
                        {researcher.subInstitution &&
                            <tr>
                            <th className="text-right">Sub Department</th>
                            <td>{researcher.subInstitution.label}</td>
                            </tr>
                        }
                        <tr>
                            <th className="text-right">Position</th>
                            <td>{researcher.position && researcher.position.label}</td>
                        </tr>
                        <tr>
                            <th className="text-right">Areas of Interest</th>
                            <td>{researcher.labelEntities && <ul className="list-unstyled">
                                {researcher.labelEntities.map(aoi =>
                                    <li key={aoi.id}>{aoi.label}</li>
                                )}
                            </ul>}
                            </td>
                        </tr>
                        {/*<tr>*/}
                        {/*    <th className="text-right">Clinical Research Experience</th>*/}
                        {/*    <td>{researcher.clinicalResearchExperience && researcher.clinicalResearchExperience.label}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <th className="text-right">Clinical Trials Experience</th>*/}
                        {/*    <td>{researcher.clinicalTrialsExperience && researcher.clinicalTrialsExperience.label}</td>*/}
                        {/*</tr>*/}
                        <tr>
                            <th className="text-right">Comment</th>
                            <td>{researcher.comment}</td>
                        </tr>
                    </tbody>
                </table>
                <Dialog disableBackdropClick open={this.state.editResearcherDialogOpen} onClose={this.handleEditResearcherDialogClose} fullWidth={true} maxWidth="lg" aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Edit Researcher</DialogTitle>
                    <DialogContent>
                        <ResearcherForm researcherId={this.state.researcherId} onSubmit={this.handleResearcherUpdated} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleEditResearcherDialogClose} color="primary">Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}